import { useState } from 'react';
import { Box, Container, Tabs, Tab, Paper } from '@mui/material';
import { Text } from '@qwickapps/react-framework';
import { useAuth } from '@qwickapps/auth-client';
import ProfileSettings from '../components/settings/ProfileSettings';
import UsersSettings from '../components/settings/UsersSettings';
import OrganizationSettings from '../components/settings/OrganizationSettings';
import BillingSettings from '../components/settings/BillingSettings';
import ShorthandsSettings from '../components/settings/ShorthandsSettings';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function ProfilePage() {
  const [currentTab, setCurrentTab] = useState(0);
  const { user } = useAuth();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  if (!user) {
    return (
      <Container maxWidth="lg">
        <Box sx={{ py: 8 }}>
          <Text variant="h5" customColor="var(--theme-error)" content="Please sign in to access settings" />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Text variant="h4" gutterBottom customColor="var(--theme-text-primary)" content="Profile" />
        <Text customColor="var(--theme-text-secondary)" content="Manage your account, organization, and preferences" sx={{ mb: 4 }} />

        <Paper sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={currentTab}
              onChange={handleTabChange}
              aria-label="settings tabs"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                '& .MuiTab-root': {
                  color: 'var(--theme-text)'
                },
                '& .Mui-selected': {
                  color: 'var(--theme-primary-dark)'
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: 'var(--theme-primary-dark)'
                }
              }}
            >
              <Tab label="Profile" id="settings-tab-0" aria-controls="settings-tabpanel-0" />
              <Tab label="Users" id="settings-tab-1" aria-controls="settings-tabpanel-1" />
              <Tab label="Organization" id="settings-tab-2" aria-controls="settings-tabpanel-2" />
              <Tab label="Billing" id="settings-tab-3" aria-controls="settings-tabpanel-3" />
              <Tab label="Shorthands" id="settings-tab-4" aria-controls="settings-tabpanel-4" />
            </Tabs>
          </Box>

          <TabPanel value={currentTab} index={0}>
            <ProfileSettings />
          </TabPanel>
          <TabPanel value={currentTab} index={1}>
            <UsersSettings />
          </TabPanel>
          <TabPanel value={currentTab} index={2}>
            <OrganizationSettings />
          </TabPanel>
          <TabPanel value={currentTab} index={3}>
            <BillingSettings />
          </TabPanel>
          <TabPanel value={currentTab} index={4}>
            <ShorthandsSettings />
          </TabPanel>
        </Paper>
      </Box>
    </Container>
  );
}
